import React from "react";
import "./BlogPost.css";

import { Link } from "react-router-dom";
import { DoubleRightOutlined } from "@ant-design/icons";

import Img1 from "../Img/blog-feed-img-1.webp";

export default function BlogPost() {
  return (
    <div className="BlogPost-Body">
      <div className="BlogPost-Box">
        <p className="BlogPost-Text1">|| Blog Post</p>
        <p className="BlogPost-Text2">Latest Tips & Tricks</p>
        <BlogPostContent
          img={Img1}
          type="Business"
          date="07 February, 2021"
          text="Do not wait until you officially started business to line these up."
        />

        <BlogPostContent
          img={Img1}
          type="Business"
          date="07 February, 2021"
          text="Do not wait until you officially started business to line these up."
        />

        <BlogPostContent
          img={Img1}
          type="Business"
          date="07 February, 2021"
          text="Do not wait until you officially started business to line these up."
        />

        <BlogPostContent
          img={Img1}
          type="Business"
          date="07 February, 2021"
          text="Do not wait until you officially started business to line these up."
        />
      </div>
    </div>
  );
}

function BlogPostContent({ text, type, date, img }) {
  return (
    <div className="BlogPostContent-Body">
      <img alt="" className="BlogPostContent-Img" src={img} />

      <div className="BlogPostContent-Div1">
        <div className="BlogPostContent-Div2">
          <p className="BlogPostContent-Text1">{type}</p>
          <p className="BlogPostContent-Text1">-</p>
          <p className="BlogPostContent-Text2">{date}</p>
        </div>
        <p className="BlogPostContent-Text3">{text}</p>
      </div>

      <Link className="BlogPostContent-Link-Button" to="/blog">
        Read More
        <DoubleRightOutlined />
      </Link>
    </div>
  );
}
